import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/grant/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/grant/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/grant', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/grant', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/grant/' + id)
  }
}
